import React from 'react';
import PaymentResultPage from './PaymentResultPage';

export default function PaymentCancelledPage() {
  return <PaymentResultPage status="CANCELLED" />;
}
